/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'


import { render, staticRenderFns } from "./login.vue.js?vue&type=template&id=5140eb13&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=template&id=5140eb13&scoped=true"
import script from "./login.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=script&setup=true&lang=ts"
export * from "./login.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./login.vue.postcss?vue&type=style&index=0&id=5140eb13&prod&lang=postcss&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=style&index=0&id=5140eb13&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140eb13",
  null
  
)

export default component.exports
installComponents(component, {VanButton})
